import { HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { TotaraHttpClient } from '@cms_root/app/api-clients/totara/totara-http-client.service';
import { TotaraAuthService } from '@cms_root/app/auth/totara/services/totara-auth.service';
import { environment } from '../../../../environments/environment';
import { BaseApiService } from '../../../core/services/base-api.service';
import { TotaraMenuSection } from '../models/totara-menu.model';
import { TotaraCountry, TotaraCountryTranslation } from '../models/totara-country.model';
import { TranslationLanguage } from '../models/translation-language.model';

@Injectable({
  providedIn: 'root'
})
export class TotaraApiService extends BaseApiService {
  private readonly apiKey = environment.totaraApiKey;
  private readonly apiKeyBase64 = btoa(this.apiKey);
  private readonly totaraMenuURL = environment.totaraApi + 'api/totara_menu';
  private readonly translationsURL = environment.totaraApi + 'api/translate';
  private readonly translationLanguagesURL = environment.totaraApi + 'api/translation_languages';

  constructor(
    protected httpClient: TotaraHttpClient,
    private readonly totaraAuthService: TotaraAuthService
  ) {
    super(httpClient);
  }

  getTotaraMenu(): Observable<TotaraMenuSection[]> {
    // return this.getTotaraMenuMock();
    return this.httpClient.get<TotaraMenuSection[]>(`${this.totaraMenuURL}`, {
      headers: this.getHeaders()
    });
  }

  getTranslationLanguages(): Observable<TranslationLanguage[]> {
    return this.httpClient.get<TranslationLanguage[]>(`${this.translationLanguagesURL}`, {
      headers: this.getHeaders()
    });
  }

  getTotaraCountries(): Observable<TotaraCountry[]> {
    const language = 'en';
    const params = new HttpParams().append('component', 'core_countries').append('language', language);

    return this.httpClient
      .get<TotaraCountryTranslation>(`${this.translationsURL}`, {
        params,
        headers: this.getHeaders()
      })
      .pipe(map((translation) => translation[language]));
  }

  protected getHeaders(options?: { [name: string]: any }): HttpHeaders {
    const token = this.totaraAuthService.getTokenFromLocalStorage();

    return super.getHeaders({
      Authorization: `Bearer ${token}`,
      'X-Client': `Basic ${this.apiKeyBase64}`,
      ...options
    });
  }
}
